import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { formatFileSize } from '../../utils/helper';
import { ReactReader } from 'react-reader';
import Loader from '../Loader/Loader';
import './EpubFileViewer.scss';
import { CordovaFileDetail, ElectronFileDetail } from '../../utils/interface';
import { Tooltip } from '@mui/material';


interface Material {
  filename: string;
  filepath: string;
  filesize: number;
  isclassroom: boolean;
  coverimagepath?: string;
  authorname?: string;
}

interface PropsType {
  fileUrl: string;
  fileData: Material | undefined | CordovaFileDetail | ElectronFileDetail | null;
}

const EpubFileViewer: FC<PropsType> = ({ fileUrl, fileData }) => {
  const [location, setLocation] = useState<string | number>(0)

   const textRef = useRef<HTMLDivElement>(null);
    const [isEllipsisActive, setIsEllipsisActive] = useState(false);
  
    // Function to check if text is truncated
    const checkEllipsis = useCallback(() => {
      if (textRef.current) {
        setIsEllipsisActive(textRef.current.scrollWidth > textRef.current.clientWidth);
      }
    }, []);
  
    useEffect(() => {
      checkEllipsis(); // Check on mount
      window.addEventListener("resize", checkEllipsis); // Recheck on resize
  
      return () => window.removeEventListener("resize", checkEllipsis); // Cleanup on unmount
    }, [checkEllipsis, fileData?.filename]);

  return (
    <div className="EpubFileViewContainer">
      {(fileData) && (
        <div className="FileHeader">
           <Tooltip title={isEllipsisActive ? fileData?.filename : ""}>
                <div ref={textRef} className="fileName">
                  {fileData?.filename|| 'Untitled File'}
                </div>
                </Tooltip>
          <div className="fileSize">
            Size: {fileData?.filesize ? formatFileSize(fileData.filesize) : '0 MB'}
          </div>
        </div>
      )}
      <div className="frameContainer">
        <ReactReader
            url={fileUrl}
            loadingView={<Loader />}
            location={location}
            locationChanged={(epubcfi: string) => setLocation(epubcfi)}
            epubOptions={{
                flow: 'paginated',
                manager: 'default',
                allowPopups: true,
                allowScriptedContent: true
            }}
            epubInitOptions={{
                openAs: 'epub',
            }}
        />       
      </div>
    </div>
  );
};

export default EpubFileViewer;
